import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'

import style from './Preloader.module.scss'

interface PreloaderType {
  classModifiers?: string[]
}

const Preloader = ({ classModifiers }: PreloaderType) => {
  const classList = classModifiers
    ? classModifiers.map((el: string) => `${style['Preloader--' + el]}`)
    : []

  return (
    <motion.div
      key='preloader'
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, easings: 'easeOut' }}
      className={`${style.Preloader} ${classList?.join(' ')}`}
    >
      <h2>загрузка данных...</h2>
    </motion.div>
  )
}

export default Preloader
